<template>
    <div class="employee-tab-inner">
        <!--<ul class="list-group mb-3 " v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>-->
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="pf-reporting-tab payroll-reporting-tab" id="nav-tabContent-intro3" v-if="$acl['pf/get-distribution-list'] > 0">
                {{checkFFLimit}}

                 <b-tabs content-class="mt-3 reports-tab-wrapper pb-4" nav-wrapper-class="mb-2 mt-2 reports-tab-nav">

                    <b-form>
                        <!-- <input type="hidden" v-model="fdata.employee_id" name="employee_id"> -->

                        <b-tab lazy>

                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/fund_distribution.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Distribute Profit</h5>
                                    <p> Distribute profit among PF registered employees.</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                                </div>

                            </template>
                            <div class="">

                                <b-modal id="bv-modal-profit-distribution" size="lg" hide-footer title="Distribute Profit">
                                        <div class="clearfix company-form-container mt-2">
                                            <b-overlay :show="showoverlayprofit" class="showoverlayprofit" rounded="sm">


                                            <b-form :refreshkey="componentKey">
                                                <div class="clearfix  pt-3">
                                                    <div class="col-md-12 float-left pt-2">

                                                        <b-form-group id="profit_amount-group" label="Amount of Profit" class="required-field" label-for="profit_amount">
                                                            <b-form-input id="profit_amount" name="profit_amount" v-model="distribution_fdata.profit_amount" v-validate="{ required: true , decimal:2}" :state="validateState('profit_amount')"   aria-describedby="profit_amount-feedback" data-vv-as="Amount of Profit" data-vv-validate-on="none"></b-form-input>
                                                            <b-form-invalid-feedback id="profit_amount-feedback">{{ veeErrors.first('profit_amount') }}</b-form-invalid-feedback>
                                                        </b-form-group>

                                                        <b-form-group id="profit_distribution_type-group"   label-for="profit_distribution_type" class="required-field" label="Profit Distribution Timing">
                                                            <b-form-select id="profit_distribution_type"  v-model="profit_distribution_type"  name="profit_distribution_type" :options="profit_distribution_type_options" v-validate="{ required: true}" :state="validateState('profit_distribution_type')"   aria-describedby="profit_distribution_type-feedback" data-vv-as="Profit Distribution Timing" data-vv-validate-on="none"></b-form-select>
                                                            <b-form-invalid-feedback id="profit_distribution_type-feedback">{{ veeErrors.first('profit_distribution_type') }}</b-form-invalid-feedback>
                                                        </b-form-group>


                                                        <b-form-group id="profit_fiscal_year-group" class="required-field" label-for="profit_fiscal_year" label="Fiscal Year" v-show="profit_distribution_type=='1' || profit_distribution_type=='4' ">
                                                            <template v-if="pf_settings.pf_year_end.opt_value != 12">
                                                                 <b-form-select id="profit_fiscal_year" v-model="profit_fiscal_year"  name="profit_fiscal_year" v-validate="{ required: true}" :state="validateState('profit_fiscal_year')"   aria-describedby="profit_fiscal_year-feedback" data-vv-as="Fiscal Year" data-vv-validate-on="none" :disabled="profit_distribution_type != '1' && profit_distribution_type !='4'">
                                                                <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                <b-form-select-option v-for="(fiscal_year, n) in $fiscal_years" :key="n" :value="fiscal_year">{{fiscal_year}}</b-form-select-option>
                                                            </b-form-select>
                                                            </template>
                                                            <template v-else>
                                                                <b-form-select id="profit_fiscal_year" v-model="profit_fiscal_year"  name="profit_fiscal_year" v-validate="{ required: true}" :state="validateState('profit_fiscal_year')"   aria-describedby="profit_fiscal_year-feedback" data-vv-as="Fiscal Year" data-vv-validate-on="none" :disabled="profit_distribution_type != '1' && profit_distribution_type !='4'">
                                                                <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                <b-form-select-option v-for="(year, n) in $years" :key="n" :value="year">{{year}}</b-form-select-option>
                                                            </b-form-select>
                                                            </template>


                                                            <b-form-invalid-feedback id="profit_fiscal_year-feedback">{{ veeErrors.first('profit_fiscal_year') }}</b-form-invalid-feedback>
                                                        </b-form-group>


                                                        <div class="row mt-4 no-margin" v-show="profit_distribution_type=='2'">
                                                            <b-form-group id="profit_specific_month-group"  label-for="profit_specific_month" label="Month" class="required-field" v-show="profit_distribution_type=='2'">
                                                                <b-form-select v-model="profit_specific_month" v-validate="{ required: true}" :state="validateState('profit_specific_month')"   aria-describedby="profit_specific_month-feedback" data-vv-as="Month" data-vv-validate-on="none" :disabled="profit_distribution_type != '2'">
                                                                    <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                    <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                                                </b-form-select>
                                                                <b-form-invalid-feedback id="profit_specific_month-feedback">{{ veeErrors.first('profit_specific_month') }}</b-form-invalid-feedback>
                                                            </b-form-group>

                                                            <b-form-group id="profit_specific_year-group"  label-for="profit_specific_year" label="Year" class = 'ml-3 required-field' v-show="profit_distribution_type=='2'">
                                                                <b-form-select id="profit_specific_year" v-model="profit_specific_year"  name="profit_specific_year" v-validate="{ required: true}" :state="validateState('profit_specific_year')"   aria-describedby="profit_specific_year-feedback" data-vv-as="Year" data-vv-validate-on="none" :disabled="profit_distribution_type != '2'">
                                                                    <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                    <b-form-select-option v-for="(year, n) in $years" :key="n" :value="year">{{year}}</b-form-select-option>
                                                                </b-form-select>
                                                                 <b-form-invalid-feedback id="profit_specific_year-feedback">{{ veeErrors.first('profit_specific_year') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>


                                                        <div class="row mt-4 no-margin" v-show="profit_distribution_type=='3'" >
                                                            <b-form-group id="profit_specific_range_from_month-group"  label-for="profit_specific_range_from_month" label="From Month" class = 'required-field' v-show="profit_distribution_type=='3'">
                                                                <b-form-select v-model="profit_specific_range_from_month" v-validate="{ required: true}" :state="validateState('profit_specific_range_from_month')"   aria-describedby="profit_specific_range_from_month-feedback" data-vv-as="From Month" data-vv-validate-on="none" :disabled="profit_distribution_type != '3'">
                                                                    <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                    <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                                                </b-form-select>
                                                                <b-form-invalid-feedback id="profit_specific_range_from_month-feedback">{{ veeErrors.first('profit_specific_range_from_month') }}</b-form-invalid-feedback>
                                                            </b-form-group>

                                                            <b-form-group id="profit_specific_range_from_year-group"  label-for="profit_specific_range_from_year" label="From Year" class = 'ml-3 required-field' v-show="profit_distribution_type=='3'">
                                                                <b-form-select id="profit_specific_range_from_year" v-model="profit_specific_range_from_year"  name="profit_specific_range_from_year" v-validate="{ required: true}" :state="validateState('profit_specific_range_from_year')"   aria-describedby="profit_specific_range_from_year-feedback" data-vv-as="From Year" data-vv-validate-on="none" :disabled="profit_distribution_type != '3'">
                                                                    <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                    <b-form-select-option v-for="(year, n) in $years" :key="n" :value="year">{{year}}</b-form-select-option>
                                                                </b-form-select>
                                                                <b-form-invalid-feedback id="profit_specific_range_from_year-feedback">{{ veeErrors.first('profit_specific_range_from_year') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>

                                                        <div class="row mt-4 no-margin" v-show="profit_distribution_type=='3'">
                                                            <b-form-group id="profit_specific_range_to_month-group"  label-for="profit_specific_range_to_month" label="To Month" class = 'required-field' v-show="profit_distribution_type=='3'">
                                                                <b-form-select v-model="profit_specific_range_to_month" v-validate="{ required: true}" :state="validateState('profit_specific_range_to_month')"   aria-describedby="profit_specific_range_to_month-feedback" data-vv-as="To Month" data-vv-validate-on="none" :disabled="profit_distribution_type != '3'">
                                                                    <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                    <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                                                </b-form-select>
                                                                <b-form-invalid-feedback id="profit_specific_range_to_month-feedback">{{ veeErrors.first('profit_specific_range_to_month') }}</b-form-invalid-feedback>
                                                            </b-form-group>

                                                            <b-form-group id="profit_specific_range_to_year-group"  label-for="profit_specific_range_to_year" label="To Year" class = 'ml-3 required-field' v-show="profit_distribution_type=='3'">
                                                                <b-form-select id="profit_specific_range_to_year" v-model="profit_specific_range_to_year"  name="profit_specific_range_to_year" v-validate="{ required: true}" :state="validateState('profit_specific_range_to_year')"   aria-describedby="profit_specific_range_to_year-feedback" data-vv-as="To Year" data-vv-validate-on="none" :disabled="profit_distribution_type != '3'">
                                                                    <b-form-select-option value="">Please Select ...</b-form-select-option>
                                                                    <b-form-select-option v-for="(year, n) in $years" :key="n" :value="year">{{year}}</b-form-select-option>
                                                                </b-form-select>
                                                                <b-form-invalid-feedback id="profit_specific_range_to_month-feedback">{{ veeErrors.first('profit_specific_range_to_year') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>


                                                        <!-- <b-form-group id="profit_date-group" label="Date [YYYY-MM-DD]" class="required-field" label-for="profit_date">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="profit_date" name="profit_date" v-model="distribution_fdata.profit_date" type="text" v-validate="{ required: true}" :state="validateState('profit_date')" placeholder="YYYY-MM-DD" autocomplete="off"  aria-describedby="profit_date-feedback" data-vv-as="Date" data-vv-validate-on="none"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-form-datepicker id="profit_date_picker" :max="date_min" button-only right locale="en-US"  v-model="distribution_fdata.profit_date"></b-form-datepicker>
                                                                </b-input-group-append>
                                                                <b-form-invalid-feedback id="profit_date-feedback">{{ veeErrors.first('profit_date') }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group> -->

                                                        <b-form-group  id="profit_details-group" label="Details" class="required-field" label-for="profit_details">
                                                            <b-form-textarea id="profit_details" name="profit_details" rows="3" max-rows="6"  no-resize v-model="distribution_fdata.profit_details" v-validate="{ required: true}" :state="validateState('profit_details')"  aria-describedby="profit_details-feedback" data-vv-as="Profit Details"></b-form-textarea>
                                                            <b-form-invalid-feedback id="profit_details-feedback">{{ veeErrors.first('profit_details') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>

                                                <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;">
                                                    <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" type="submit" variant="primary" @click.prevent="onSubmitDistributeForm">Submit</b-button>
                                                    <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="primary" @click="resetForm()">Reset</b-button>
                                                </div>

                                            </b-form>
                                        </b-overlay>
                                        </div>
                                </b-modal>

                                <!-- <div class="col-12 text-right pr-0"><b-button  v-if="$acl['pf/get-distribution-list'] > 1" class="mb-2 w-100" @click="showProfitDistributeForm()" style="max-width: 325px;">Distribute Profit</b-button></div>
                                <pf-reclaim-list :pf_settings="pf_settings" :pageurl="pageurl" :distribution_type="1" :key="profit_list_key"></pf-reclaim-list> --> <!-- Mustafijur commented the code -->

                                <div class="reports-tab-nav">
                                    <div class="col-12 text-right"> <!-- Mustafijur: 23-05-2026: removed pr-0 -->
                                        <b-button class="mb-2" @click="showProfitDistributeForm()" style="max-width: 325px;">Distribute Profit</b-button>
                                    </div>
                                    <pf-reclaim-list :pf_settings="pf_settings" :pageurl="pageurl" :distribution_type="1" :key="profit_list_key"></pf-reclaim-list>
                                </div>
                            </div>

                        </b-tab>


                        <b-tab lazy>

                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/fund_distribution.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Distribute Forfeiture Fund</h5>
                                    <p>Distribute Forfeiture Fund among PF registered employees.</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                                </div>

                            </template>

                            <div class="clearfix company-form-container reports-tab-nav mt-3">
                                <div class="row no-gutters py-2">
                                    <div class="col-sm-6 px-3 company-form-box-title">Distribute Forfeiture Fund |
                                        <span class="text_color_gray">Total Distributable Fund &nbsp;&#2547&nbsp;
                                        {{ formatMoney(this.total_ff_fund) }}</span>
                                    </div>
                                </div>

                                <b-form :refreshkey="componentKey" v-if="$acl['pf/get-distribution-list'] > 1">
                                    <div class="clearfix">

                                            <div class="col-md-12 float-left pt-2">

                                                <b-form-group id="forfeiture_amount-group" label="Forfeiture Amount" class="required-field" label-for="forfeiture_amount">
                                                    <b-form-input id="forfeiture_amount" name="forfeiture_amount" v-model="forfeiture_fdata.forfeiture_amount" v-validate="{ required: true, decimal: 2 }" :state="validateState('forfeiture_amount')" aria-describedby="forfeiture_amount-feedback" data-vv-as="Forfeiture Amount"></b-form-input>
                                                    <b-form-invalid-feedback id="forfeiture_amount-feedback">{{ veeErrors.first('forfeiture_amount') }}</b-form-invalid-feedback>
                                                    <div class="invalid-feedback" style="display:block !important;" v-if="this.forfeiture_distribution_form_disable==true">The Forfeiture Amount must be less or equal to Total Distributable Fund</div>

                                                </b-form-group>

                                        <b-form-group id="forfeiture_date-group" label="Date [YYYY-MM-DD]" class="required-field" label-for="forfeiture_date">

                                                    <b-input-group class="mb-3">
                                                        <b-form-input id="forfeiture_date" name="forfeiture_date" v-model="forfeiture_fdata.forfeiture_date" v-validate="{ required: true}" :state="validateState('forfeiture_date')" type="text" placeholder="YYYY-MM-DD" autocomplete="off"  aria-describedby="forfeiture_date-feedback" data-vv-as="Date"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-form-datepicker id="forfeiture_date_picker" :max="date_min" button-only right locale="en-US" v-model="forfeiture_fdata.forfeiture_date"></b-form-datepicker>
                                                        </b-input-group-append>
                                                        <b-form-invalid-feedback id="forfeiture_date-feedback">{{ veeErrors.first('forfeiture_date') }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                        </b-form-group>

                                                <b-form-group  id="forfeiture_details-group" label="Details" class="required-field" label-for="forfeiture_details">
                                                    <b-form-textarea id="forfeiture_details" name="forfeiture_details" rows="3" max-rows="6"  no-resize v-model="forfeiture_fdata.forfeiture_details" v-validate="{required: true }" :state="validateState('forfeiture_details')" aria-describedby="forfeiture_details-feedback" data-vv-as="Details"></b-form-textarea>
                                                    <b-form-invalid-feedback id="forfeiture_details-feedback">{{ veeErrors.first('forfeiture_details') }}</b-form-invalid-feedback>
                                                </b-form-group>



                                            </div>
                                    </div>

                                    <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;"> <!-- Mustafijur: 23-05-2026: text-center to text-right -->
                                        <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2 custom-wizard-btn"
                                            variant="primary" @click="resetForm()">Reset</b-button>
                                        <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" type="submit"
                                            variant="primary" :disabled='this.forfeiture_distribution_form_disable'
                                            @click.prevent="onSubmitDistributeForfeitureForm">Submit</b-button>
                                    </div>
                                </b-form>
                            </div>
                            <pf-reclaim-list  :pf_settings="pf_settings"  :pageurl="pageurl" :distribution_type="2" :key="ff_list_key"></pf-reclaim-list>
                        </b-tab>

                        <b-tab lazy>
                            <template v-slot:title>
                                 Reclaim Forfeiture Fund <div class="float-right"><b-icon stacked icon="exclamation-circle" style="width: 20px; height: 20px;" variant="danger" v-if="tab_two_error"></b-icon></div>
                            </template>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/fund_distribution.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Reclaim Forfeiture Fund</h5>
                                    <p>Process forfeiture reclaims.</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                                </div>

                            </template>

                             <div class="clearfix company-form-container reports-tab-nav mt-3">
                                <div class="row no-gutters">
                                    <div class="col-sm-6 px-3 company-form-box-title">Reclaim Forfeiture Fund |
                                        <span class="text_color_gray">Total Distributable Fund &nbsp;&#2547&nbsp;
                                        {{ formatMoney(this.total_ff_fund) }}</span>
                                    </div>
                                </div>


                                <b-form :refreshkey="componentKey" v-if="$acl['pf/get-distribution-list'] > 1">
                                    <div class="clearfix">

                                        <div class="col-md-12 float-left pt-2">

                                            <b-form-group id="reclaim_amount-group" label="Reclaim Amount" class="required-field" label-for="reclaim_amount">
                                                <b-form-input id="reclaim_amount" name="reclaim_amount" v-model="forfeiture_reclaim_data.reclaim_amount" v-validate="{ required: true , decimal:2, max:this.total_ff_fund}" aria-describedby="reclaim_amount-feedback" :state="validateState('reclaim_amount')"  data-vv-as="Reclaim Amount"></b-form-input>
                                                <b-form-invalid-feedback id="reclaim_amount-feedback">{{ veeErrors.first('reclaim_amount') }}</b-form-invalid-feedback>
                                                <div class="invalid-feedback" style="display:block !important;" v-if="this.forfeiture_reclaim_form_disable==true">The Forfeiture Reclaim Amount must be less or equal to Total Distributable Fund</div>
                                            </b-form-group>

                                        <b-form-group id="reclaim_date-group" label="Date [YYYY-MM-DD]" class="required-field" label-for="reclaim_date">

                                                <b-input-group class="mb-3">
                                                    <b-form-input id="reclaim_date" name="reclaim_date" v-model="forfeiture_reclaim_data.reclaim_date" type="text" v-validate="{ required: true }" placeholder="YYYY-MM-DD" :state="validateState('reclaim_date')"  autocomplete="off"  aria-describedby="reclaim_date-feedback" data-vv-as="Date"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-form-datepicker id="reclaim_date_picker" :max="date_min" button-only right locale="en-US" v-model="forfeiture_reclaim_data.reclaim_date"></b-form-datepicker>
                                                    </b-input-group-append>
                                                    <b-form-invalid-feedback id="reclaim_date-feedback">{{ veeErrors.first('reclaim_date') }}</b-form-invalid-feedback>
                                                </b-input-group>
                                            </b-form-group>

                                            <b-form-group  id="reclaim_details-group" label="Details" class="required-field" label-for="reclaim_details">
                                                <b-form-textarea id="reclaim_details" name="reclaim_details" rows="3" max-rows="6"  no-resize v-model="forfeiture_reclaim_data.reclaim_details" v-validate="{ required: true }" :state="validateState('reclaim_details')"  aria-describedby="reclaim_details-feedback" data-vv-as="Details"></b-form-textarea>
                                                <b-form-invalid-feedback id="reclaim_details-feedback">{{ veeErrors.first('reclaim_details') }}</b-form-invalid-feedback>
                                            </b-form-group>

                                        </div>
                                    </div>

                                    <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-right" style="margin-right: 18px;"> <!-- Mustafijur: 23-05-2026: text-center to text-right -->
                                        <b-button class="border rounded bg-light  py-1 px-5 mt-4 ml-2 custom-wizard-btn" variant="primary" @click="resetForm()">Reset</b-button>
                                        <b-button class="border rounded bg-light  py-1 px-5 mt-4 ml-2" type="submit" variant="primary" :disabled='this.forfeiture_reclaim_form_disable' @click.prevent="onSubmitDistributeReclaimForm">Submit</b-button>
                                    </div>
                              </b-form>
                            </div>

                            <pf-reclaim-list  :pf_settings="pf_settings" :pageurl="pageurl" :distribution_type="3" :key="list_key"></pf-reclaim-list>
                        </b-tab>

                    </b-form>
                    <!-- Form ends here -->
                </b-tabs>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import moment from 'moment';

    export default{

        mounted() {
            if(this.employeedata.date_of_birth == '0000-00-00')
                this.fdata.date_of_birth = '';

            if(this.employeedata.last_working_day == '0000-00-00')
                this.fdata.last_working_day = '';

            this.showoverlay = false;
        },
        props: ['flg','pageurl'],

        data(){
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {
                date_min:minDate,
                distribution_fdata :
                {
                    profit_amount:"",
                    profit_date: "",
                    profit_details : "",
                    distribution_type: 1,
                },
                forfeiture_fdata:
                {
                    distribution_type:2,
                    forfeiture_amount:"",
                    forfeiture_date:"",
                    forfeiture_details:"",
                },
                forfeiture_reclaim_data:
                {
                    reclaim_amount:"",
                    reclaim_date :"",
                    reclaim_details: "",
                    distribution_type:3,
                },
                // f_y: ['2013-2014','2014-2015','2015-2016','2016-2017','2017-2018','2018-2019','2019-2020','2020-2021','2021-2022','2022-2023'],
                // f_y: $fiscal_years,


                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],

                profit_distribution_type:null,
                // Sepicific Fiscal Year
                profit_fiscal_year:'',
                // Specific Month
                profit_specific_year:'',
                profit_specific_month:'',

                // Specifict Month Range

                profit_specific_range_from_year:'',
                profit_specific_range_from_month:'',
                profit_specific_range_to_year:'',
                profit_specific_range_to_month:'',


                componentKey: 0,

                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,

                readonly : false,
                trz_display_form : 'd-none',
                user_level : 0,
                has_changed : false,
                reset_flg : false,
                has_changed_flg : false,

                tab_one_error : false,
                tab_two_error : false,
                tab_three_error : false,
                disableme : false,
                disabled : false,

                formatted: '',
                selected: '',

                profit_distribution_type_options:[
                    { value: null, text: "Please Select ..." },
                    { value: "1", text: "Fiscal Year" },
                    // { value: "2", text: "Specific Month" },
                    // { value: "3", text: "Month Range" },
                ],


                fake : 0,

                date_of_birth : '',
                date_of_joining : '',
                total_ff_fund:0,

                errormsg:[],

                fdata: {
                            employee_id:0,
                            company_id:1,
                            name:null,
                            email: null,
                            residency:null ,
                            gender:null ,
                            marital_status:'' ,
                            department_id:null ,
                            leave_policy_id: 0 ,
                            jobposition_id:null,
                            branch_id:null,
                            manager_id:0,

                            nid:'',
                            passport:'',
                            etin:'',
                            address:'',
                            emergency_contact:'',
                            beneficiary_name:'',
                            employee_code:'',
                            pic:'demo.jpg',
                            draft_flg  : 0,
                        },
                        pf_settings :{pf_year_end:{ opt_value: 0, status: 0 },},

                xdata : {

                },
                employeedata:[],
                edit_user:false,
                new_capability:true,

                department : [],
                jobposition : [],
                branch : [],
                manager : [],
                leave_policies : [],

                employee_pic : '',
                form_pic:null,
                form_nid_scan:null,
                form_etin_scan:null,


                form_passport_scan:null,

                residency: [
                    { value: null, text: "Select..." },
                    { value: "Resident", text: "Resident" },
                    { value: "Non Resident", text: "Non Resident" }
                ],
                nationality: [
                    { value: null, text: "Select..." },
                    { value: "Bangladeshi", text: "Bangladeshi" },
                    { value: "Non Bangladeshi", text: "Non Bangladeshi" }
                ],
                gender:[
                    { value: null, text: "Select..." },
                    { value: "Male", text: "Male" },
                    { value: "Female", text: "Female" },
                    { value: "Third Gender", text: "Third Gender" },
                ],
                marital_status:[
                    { value: '', text: "Select..." },
                    { value: "Single", text: "Single" },
                    { value: "Married", text: "Married" },
                    { value: "Widower", text: "Widower" },
                    { value: "Divorced", text: "Divorced" },
                ],

                bankurl : '/bankinfo/',

                logoUrl : '/images/employee/' + 'demo.jpg',
                logoUploaded: false,
                showLogoUploader: false,

                /****new vars ***/
                profit_amount: 0,
                profit_date: '',
                profit_details: '',
                forfeiture_amount: 0,
                forfeiture_date: '',
                forfeiture_details: '',
                reclaim_amount: 0,
                reclaim_date: '',
                reclaim_details: '',
                list_key:0,
                profit_list_key:0,
                ff_list_key:0,
                forfeiture_reclaim_form_disable :false,
                forfeiture_distribution_form_disable :false,
                showoverlayprofit:false,
            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },
            maxStartDate: function() {
                return moment()
                    .startOf('month')
                    .add(1, 'months')
                    .endOf('month').format('DD/MM/YYYY');
            },
            showProfitDistributeForm: function()
            {
                this.$bvModal.show('bv-modal-profit-distribution');




            },
            showMessage: function()
            {
                let childdata = {employee_id:this.fdata.employee_id , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg};
                this.$emit('childToParent', childdata);
            },
            onContext(ctx) {
                // The date formatted in the locale, or the `label-no-date-selected` string
                //this.formatted = ctx.selectedFormatted;
                // The following will be an empty string until a valid date is entered
                //this.selected = ctx.selectedYMD;
                this.fake = this.fake + 1;
            },
            getUserLevel: function()
            {

                let currentObj = this;
                axios.get(this.$api_url+'/user-level')
                    .then(function (response) {
                        this.user_level = response.data;

                    }.bind(this)).catch(function (error){ currentObj.serverError(error); });
            },
            getCountryData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/countries/' , {
                    params: {

                    }
                }).then(function(response){
                    this.nationality = response.data;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            trz_display: function()
            {
                this.trz_display_form = '';
                this.readonly = !this.readonly;
            },
            toggleLogoUploader() {
				this.showLogoUploader = !this.showLogoUploader;
			},
			cropSuccess(imgDataUrl, field){

				this.logoUrl = imgDataUrl;
                this.logoUploaded = true;
			},
            getEmployee: function(reset = 0 , flg = 1){
                if(!this.checkNet()) return false;
                let currentObj = this;

                // if user level is officer always show the
                /*let flg = 0;
                if(reset == 0)
                {
                    if(this.user_level > 3)
                        flg = 1;
                }*/


                axios.get(this.$api_url+'/employee/details?flg='+flg+'&reset='+reset)
                    .then(function (response) {

                        if(response.data.employee_id > 0)
                        {

                            for (let [key, value] of Object.entries(response.data))
                            {
                                this.xdata[key] = value;
                                this.fdata[key] = value;
                            }


                            if((response.data.phone != null) && (response.data.phone != ''))
                            {
                                let p = response.data.phone;
                                this.fdata.phone = response.data.phone.slice(3,15);
                                this.xdata.phone = p.slice(3,15);
                            }

                            this.date_of_birth = moment(String(response.data.date_of_birth)).format('D MMMM YYYY');
                            this.date_of_joining = moment(String(response.data.date_of_joining)).format('D MMMM YYYY');


                            this.logoUrl = '/images/employee/'+ this.fdata.company_id + '/' + this.fdata.pic;
                            this.disableme = true;
                            this.showMessage();

                            if(this.fdata.email == 'null'){ this.fdata.email = ''; this.xdata.email = ''; }
                            if(this.fdata.passport == 'null'){ this.fdata.passport = ''; this.xdata.passport = ''; }
                            if(this.fdata.emergency_contact == 'null'){ this.fdata.emergency_contact = ''; this.xdata.emergency_contact = ''; }
                            if(this.fdata.employee_code == 'null'){ this.fdata.employee_code = ''; this.xdata.employee_code = ''; }
                            if(this.fdata.etin == 'null'){ this.fdata.etin = ''; this.xdata.etin = ''; }
                            if(this.fdata.marital_status == 'null'){ this.fdata.marital_status = ''; this.xdata.marital_status = ''; }


                            this.edit_user = true;

                            if(this.fdata.draft_flg == 1)
                            {
                                this.has_changed_flg = true;
                                this.reset_flg = true;
                            }


                            if(reset == 1)
                            {
                                this.reset_flg = false;
                                this.has_changed_flg = true;
                            }


                            this.form_pic = null;
                            this.form_nid_scan = null;
                            this.form_etin_scan = null;

                            this.new_capability = true;
                            this.errormsg = [];
                            this.$validator.reset();

                            this.readonly = true;
                            this.trz_display_form = 'd-none';

                        }else{
                           if(response.data.capability==false){
                            this.new_capability = false;
                            this.errormsg = [];
                            this.errormsg[0] = ["You are not allowed to add more employee!!!"];
                           }
                           else{

                            this.readonly = false;
                            this.trz_display_form = '';

                            this.new_capability = true;
                            this.errormsg = [];
                           }

                        }

                    }.bind(this)).catch(function (error){ currentObj.serverError(error); });
            },
            getDepartments: function(){
              axios.get(this.$api_url+'/department/list')
              .then(function (response) {

                    this.department = [{ value: null, text: "Select..." } ] . concat(response.data);

                    //this.fdata.department_id = null;
                    //alert(this.department[this.fdata.department_id]['text']);

              }.bind(this));

            },
            getJobPosition: function() {

                axios.get(this.$api_url+'/jobposition/options',{
                 params: {

                 }
              }).then(function(response){

                    //this.jobposition = [{ value: null, text: "Select..." } ] . concat(response.data);
                    ///this.fdata.jobposition_id = null;
                    this.jobposition = [{ value: null, text: "Select..." } ] . concat(response.data);
                }.bind(this));
            },

            getBranches: function(){
              axios.get(this.$api_url+'/branch/list')
              .then(function (response) {
                    this.branch = [{ value: null, text: "Select..." } ] . concat(response.data);
              }.bind(this));

            },

            getManagers: function(){
              axios.get(this.$api_url+'/manager')
              .then(function (response) {
                    this.manager = [{ value: 0, text: "Select..." } ] . concat(response.data);
              }.bind(this));

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.getTotalForfeitureFund();
                this.forfeiture_reclaim_form_disable =false;
                this.forfeiture_distribution_form_disable =false;

                this.profit_distribution_type= null;
                // Sepicific Fiscal Year
                this.profit_fiscal_year= '';
                // Specific Month
                this.profit_specific_year= '';
                this.profit_specific_month= '';

                // Specifict Month Range

                this.profit_specific_range_from_year= '';
                this.profit_specific_range_from_month= '';
                this.profit_specific_range_to_year= '';
                this.profit_specific_range_to_month = '';

               this.distribution_fdata =
                {
                    profit_amount:"",
                    profit_date: "",
                    profit_details : "",
                    distribution_type: 1,
                },
                this.forfeiture_fdata =
                {
                    forfeiture_amount:"",
                    forfeiture_date:"",
                    forfeiture_details:"",
                    distribution_type:2,
                },
                this.forfeiture_reclaim_data=
                {
                    reclaim_amount:"",
                    reclaim_date :"",
                    reclaim_details: "",
                    distribution_type:3,


                },

                this.reset_flg = true;

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;

                this.tab_one_error = false;
                this.tab_two_error = false;
                this.tab_three_error = false;

                this.has_changed = false;

                this.$validator.validate().then(result => {
                    if (!result) {

                        if(this.veeErrors.first('profit_amount'))
                        {
                            this.tab_one_error = true;
                        }
                        if(this.veeErrors.first('forfeiture_amount') || this.veeErrors.first('forfeiture_date') )
                        {
                            this.tab_two_error = true;
                        }


                        this.$bvToast.toast("Please fill all required fields [marked red]", {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });

                        return;
                    }


                    e.preventDefault();
                    let currentObj = this;
                    currentObj.errormsg = '';
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    if(this.logoUploaded)
                        formData.append('form_pic', this.logoUrl);

                    if(this.form_nid_scan)
                        formData.append('form_nid_scan', this.form_nid_scan);

                    if(this.form_etin_scan)
                        formData.append('form_etin_scan', this.form_etin_scan);


                    if(this.form_passport_scan)
                        formData.append('form_passport_scan', this.form_passport_scan);



                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        if(fval == 'null')
                            fval = '';
                        formData.append(nm, fval);
                        if(this.fdata[key] != this.xdata[key])
                            this.has_changed = true;

                    }

                    if(this.has_changed_flg)
                        this.has_changed = true;

                    if(this.has_changed == false)
                    {
                        /*this.$bvToast.toast('No changes found.', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });

                        return;*/
                    }

                    this.showoverlay = true;

                    axios.post(this.$api_url+'/employee/account', formData, config)
                                .then(function (response)
                                {
                                    this.showoverlay = false;

                                    if(response.data.status == 0)
                                    {
                                        this.$bvToast.toast(response.data.msg, {
                                            title: `error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                    }
                                    else
                                    {
                                        this.$bvToast.toast("Saved!", {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                        this.disableme = true;
                                        this.edit_user = true;

                                        if(this.reset_flg == true)
                                            this.reset_flg = false


                                        this.fdata = response.data.employee_info;
                                        this.fdata.phone = response.data.employee_info.phone.slice(3,15);

                                        if(this.fdata.email == 'null') this.fdata.email = '';

                                        if(this.fdata.passport == 'null') this.fdata.passport = '';
                                        if(this.fdata.emergency_contact == 'null') this.fdata.emergency_contact = '';
                                        if(this.fdata.employee_code == 'null') this.fdata.employee_code = '';

                                        this.showMessage();

                                        this.showoverlay = false;

                                        this.readonly = true;
                                        this.trz_display_form = 'd-none';
                                    }


                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.showoverlay = false;
                                    currentObj.serverError(error);

                                });
                });
            },

            // on Submit distribution form start

            onSubmitDistributeForm()
            {
                this.$validator.validate().then(result =>
                {
                    if (!result)
                    {
                        return;
                    }
                    let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.distribution_fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    formData.append('profit_distribution_type', this.profit_distribution_type);

                    if(this.profit_distribution_type == 1)
                    {
                        // Sepicific Fiscal Year
                        formData.append('profit_fiscal_year', this.profit_fiscal_year);
                    }
                    else if(this.profit_distribution_type == 2)
                    {
                        // Specific Month
                        formData.append('profit_specific_year', this.profit_specific_year);
                        formData.append('profit_specific_month', this.profit_specific_month);

                    }
                    else if (this.profit_distribution_type == 3)
                    {
                        // Specifict Month Range
                        formData.append('profit_specific_range_from_year', this.profit_specific_range_from_year);
                        formData.append('profit_specific_range_from_month', this.profit_specific_range_from_month);
                        formData.append('profit_specific_range_to_year', this.profit_specific_range_to_year);
                        formData.append('profit_specific_range_to_month', this.profit_specific_range_to_month);

                    }
                    this.showoverlayprofit = true;
                    axios.post(this.$api_url+'/pf/distribute-profit/save', formData)
                        .then(function (response)
                        {
                            this.showoverlayprofit = false;
                            console.log(response.data);
                            //bk-0006 (m-3) issue starts
                            console.log('response.data :', response.data);
                            console.log('response.data.success :', response.data.success);

                            //bk-0006 (m-3) issue ends
                            if(response.data.success)
                            {
                                this.$bvToast.toast(response.data.success, {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                                });

                                this.$bvModal.hide('bv-modal-profit-distribution');
                            }
                            else if(response.data.error)
                            {
                                this.$bvToast.toast(response.data.error, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                                });
                            }

                            this.resetForm();
                            this.componentKey += 1;
                            this.profit_list_key = this.profit_list_key + 1;

                        }.bind(this))
                        .catch(function (error)
                        {
                            this.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                            for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                        });
                });
            },
            // on Submit distribution form End

            // on Submit distribution Reclaim form start
            onSubmitDistributeForfeitureForm()
            {
              this.$validator.validate().then(result =>
                {
                    if (!result)
                    {
                        return;
                    }
                     let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.forfeiture_fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }
                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/distribute-forfeiture/save', formData)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            if(response.data.success)
                            {
                                this.$bvToast.toast(response.data.success, {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                                });
                            }
                            else if(response.data.error)
                            {
                                this.$bvToast.toast(response.data.error, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                                });
                            }
                            this.ff_list_key = this.ff_list_key + 1;
                            this.resetForm();


                        }.bind(this))
                        .catch(function (error)
                        {
                            this.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                            for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                        });

                });

            },

            // on Submit distribution Reclaim form start
            onSubmitDistributeReclaimForm()
            {
                this.$validator.validate().then(result =>
                {
                    if (!result)
                    {
                        return;
                    }
                let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.forfeiture_reclaim_data))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }
                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/distribute-forfeiture-reclaim/save', formData)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            if(response.data.success)
                            {
                                this.$bvToast.toast(response.data.success, {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                                });
                            }
                            else if(response.data.error)
                            {
                                this.$bvToast.toast(response.data.error, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                                });
                            }
                            this.list_key = this.list_key + 1;
                            this.resetForm();
                        }.bind(this))
                        .catch(function (error)
                        {
                            this.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                            for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                        });
                    });
            },
            getTotalForfeitureFund: function() {

                axios.get(this.$api_url+'/pf/get-forfeiturerefund',{
              }).then(function(response){
                 if(response.data.total_ff_fund > 0)
                 {
                     this.total_ff_fund = response.data.total_ff_fund;
                 }

                }.bind(this));
            },
            getPFSettings: function()
            {
                let currentObj = this;
                axios.get(this.$api_url+'/pf/settings').then(function (response) {
                    currentObj.pf_settings = response.data.data;
                    console.log(currentObj.pf_settings);
                }.bind(this));

            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },
        },
        computed:
        {
            checkFFLimit()
            {
                if(this.forfeiture_fdata.forfeiture_amount > this.total_ff_fund)
                {
                    this.forfeiture_distribution_form_disable =true;
                }
                else
                {
                    this.forfeiture_distribution_form_disable =false;
                }


                if(this.forfeiture_reclaim_data.reclaim_amount > this.total_ff_fund)
                {
                     this.forfeiture_reclaim_form_disable =true;
                }
                else
                {
                    this.forfeiture_reclaim_form_disable =false;
                };
            },
            years ()
            {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },

        },
        created: function(){
            if(!this.checkNet()) return false;

            if(this.$acl['pf/get-distribution-list'] > 0)
            {
                this.getPFSettings();
                this.getTotalForfeitureFund();
                this.getUserLevel();
                this.getDepartments();
                this.getJobPosition();
                this.getBranches();
                //this.getLeavePolicies();
                this.getManagers();
                this.getCountryData();
                //this.getEmployee();

            }

            this.$validator.reset();
        }
    }
</script>
<style>
.showoverlayprofit .b-overlay {
	height: 100%;
}
</style>
